import { Data_getInstance34t53wgrn3an7 as Data_getInstance } from './adapter/CreateSecretMutation_ResponseAdapter.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance8d9dd8emdwrf as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { CreateSecretMutationSelections_getInstance1akwpva7hkktk as CreateSecretMutationSelections_getInstance } from './selections/CreateSecretMutationSelections.mjs';
import { CreateSecretMutation_VariablesAdapter_instance2aq2ogjf8avhz as CreateSecretMutation_VariablesAdapter_instance } from './adapter/CreateSecretMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(createSecret) {
        this.u6o_1 = createSecret;
      }
      toString() {
        return 'Data(createSecret=' + toString(this.u6o_1) + ')';
      }
      hashCode() {
        return this.u6o_1 == null ? 0 : this.u6o_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!equals(this.u6o_1, other.u6o_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CreateSecretClass;
function CreateSecret() {
  if (CreateSecretClass === VOID) {
    class $ {
      constructor(secretId, description, createdTimestamp, lastUsedTimestamp, secretToken) {
        this.v6o_1 = secretId;
        this.w6o_1 = description;
        this.x6o_1 = createdTimestamp;
        this.y6o_1 = lastUsedTimestamp;
        this.z6o_1 = secretToken;
      }
      toString() {
        return 'CreateSecret(secretId=' + this.v6o_1.toString() + ', description=' + this.w6o_1 + ', createdTimestamp=' + this.x6o_1.toString() + ', lastUsedTimestamp=' + toString(this.y6o_1) + ', secretToken=' + this.z6o_1 + ')';
      }
      hashCode() {
        var result = this.v6o_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.w6o_1) | 0;
        result = imul(result, 31) + this.x6o_1.hashCode() | 0;
        result = imul(result, 31) + (this.y6o_1 == null ? 0 : this.y6o_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.z6o_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecret()))
          return false;
        if (!this.v6o_1.equals(other.v6o_1))
          return false;
        if (!(this.w6o_1 === other.w6o_1))
          return false;
        if (!this.x6o_1.equals(other.x6o_1))
          return false;
        if (!equals(this.y6o_1, other.y6o_1))
          return false;
        if (!(this.z6o_1 === other.z6o_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecret');
    CreateSecretClass = $;
  }
  return CreateSecretClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.a6p_1 = obj(Data_getInstance());
        this.b6p_1 = (new (Builder())('data', Companion_getInstance().x6p_1)).q47(CreateSecretMutationSelections_getInstance().z6p_1).l38();
        this.c6p_1 = 'ebc30c0645cf276dd3d78eb42594ec195bdc601bd1d9fe71ba29e8b002fabc48';
        this.d6p_1 = 'createSecret';
      }
      a6q() {
        return 'mutation createSecret($input: CreateSecretInput!) { createSecret(input: $input) { secretId description createdTimestamp lastUsedTimestamp secretToken } }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CreateSecretMutationClass;
function CreateSecretMutation() {
  if (CreateSecretMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.b6q_1 = input;
      }
      c6q() {
        return 'ebc30c0645cf276dd3d78eb42594ec195bdc601bd1d9fe71ba29e8b002fabc48';
      }
      operationId() {
        return this.c6q();
      }
      i4b() {
        return Companion_getInstance_0().a6q();
      }
      d6q() {
        return 'createSecret';
      }
      operationName() {
        return this.d6q();
      }
      n4a(writer, customScalarAdapters, withDefaultValues) {
        CreateSecretMutation_VariablesAdapter_instance.e6q(writer, this, customScalarAdapters, withDefaultValues);
      }
      m4a() {
        return Companion_getInstance_0().a6p_1;
      }
      toString() {
        return 'CreateSecretMutation(input=' + this.b6q_1.toString() + ')';
      }
      hashCode() {
        return this.b6q_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecretMutation()))
          return false;
        if (!this.b6q_1.equals(other.b6q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecretMutation', VOID, VOID, [Mutation()]);
    CreateSecretMutationClass = $;
  }
  return CreateSecretMutationClass;
}
//region block: exports
export {
  CreateSecret as CreateSecretg99oj6r6hso0,
  Data as Data1ybn66w6c74sz,
  CreateSecretMutation as CreateSecretMutation3m5frrt825225,
};
//endregion

//# sourceMappingURL=CreateSecretMutation.mjs.map
